import { render, staticRenderFns } from "./GroupSending.vue?vue&type=template&id=300d6c56&scoped=true&"
import script from "./GroupSending.vue?vue&type=script&lang=js&"
export * from "./GroupSending.vue?vue&type=script&lang=js&"
import style0 from "./GroupSending.vue?vue&type=style&index=0&id=300d6c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d6c56",
  null
  
)

export default component.exports